<template>
  <li
    class="brandshowcase-placeholder full-width"
  >
    <component
      :is="componentRef"
      :site-mon-config="siteMonConfig"
      :is-brand-showcase-enabled="brandShowcaseEnabled"
      :brand-showcase-view-tag-enabled="brandShowcaseViewTagEnabled"
      :brand-showcase-click-tag-enabled="brandShowcaseClickTagEnabled"
      :carousel-open-in-new-tab-enabled="carouselOpenInNewTabEnabled"
      :is-bcom="isBcom"
    />
  </li>
</template>

<script setup>
/* istanbul ignore file */
import {
  onMounted, ref, defineAsyncComponent, markRaw,
} from 'vue';
import useBrandShowcase from '../composables/useBrandShowcase';

const componentRef = ref();
const {
  siteMonConfig,
  brandShowcaseEnabled,
  brandShowcaseViewTagEnabled,
  brandShowcaseClickTagEnabled,
  carouselOpenInNewTabEnabled,
  isBcom,
} = useBrandShowcase();

onMounted(() => {
  componentRef.value = markRaw(defineAsyncComponent(() => import('@common-vue/site-monetization/src/components/BrandShowcase')));
});

</script>
